import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { useIntl } from 'react-intl';

import Avatar from './Avatar';

const AvatarStack = ({
  users,
  size,
  maxItems,
  inModal,
  onClick,
}) => {
  const intl = useIntl();
  const items = users.slice(0, maxItems);
  const moreItem = {
    uuid: uuidv4(),
    name: intl.formatMessage({
      defaultMessage: '{count} more',
    }, { count: users.length - items.length }),
  };

  return (
    <div
      role="button"
      tabIndex={0}
      className="avatar-stack"
      style={{ marginRight: !inModal ? (size / 2) : undefined }}
      onClick={onClick}
      onKeyUp={onClick}
    >
      {items.map(user => (
        <Avatar
          key={user.uuid}
          user={user}
          size={size}
          icon={user.type === 'group' ? 'users-class' : 'user'}
          stacked={true}
          tooltip={true}
        />
      ))}
      {(users.length > items.length) && (
        <Avatar
          key={moreItem.uuid}
          user={moreItem}
          size={size}
          icon="ellipsis"
          stacked={true}
          tooltip={true}
        />
      )}
    </div>
  );
};

AvatarStack.propTypes = {
  users: PropTypes.array.isRequired,
  size: PropTypes.number,
  maxItems: PropTypes.number,
  inModal: PropTypes.bool,
  onClick: PropTypes.func,
};

AvatarStack.defaultProps = {
  size: 40,
  maxItems: 5,
  inModal: false,
  onClick: (e) => { e.preventDefault(); },
};

export default AvatarStack;
